import React, { createContext, useContext, useState, ReactNode } from 'react';

export interface DeleteTripModalProps {
  id: string;
  name: string;
}

export interface DeleteTripFolderModalProps extends DeleteTripModalProps {
  folderId: string;
}

export interface DeleteTripActivityModalProps extends DeleteTripModalProps {
  activityId: string;
}

interface EditTripModalProps {
  tripId: string;
}

interface PublishTripModalProps {
  tripId: string;
}

interface CopyToTripModalProps {
  tripId: string;
}

interface MoveToTripModalProps {
  tripId: string;
}

interface ModalContextType {
  showAddTripModal: boolean;
  setShowAddTripModal: (state: boolean) => void;
  showDeleteModal: boolean;
  setShowDeleteModal: (state: boolean) => void;
  activeTripModalProps: DeleteTripModalProps | null;
  setActiveTripModalProps: (props: DeleteTripModalProps | null) => void;
  showEditTripModal: boolean;
  setShowEditTripModal: (state: boolean) => void;
  showPublishTripModal: boolean;
  setShowPublishTripModal: (state: boolean) => void;
  showCopyModal: boolean;
  setShowCopyModal: (state: boolean) => void;
  showMoveToTripModal: boolean;
  setShowMoveToTripModal: (state: boolean) => void;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export const ModalProvider: React.FC<{ children: ReactNode }> = ({
  children
}) => {
  const [showAddTripModal, setShowAddTripModal] = useState<boolean>(false);
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [activeTripModalProps, setActiveTripModalProps] =
    useState<DeleteTripModalProps | null>(null);
  const [showEditTripModal, setShowEditTripModal] = useState<boolean>(false);
  const [showPublishTripModal, setShowPublishTripModal] =
    useState<boolean>(false);
  const [showCopyModal, setShowCopyModal] = useState<boolean>(false);
  const [showMoveToTripModal, setShowMoveToTripModal] =
    useState<boolean>(false);

  return (
    <ModalContext.Provider
      value={{
        showAddTripModal,
        setShowAddTripModal,
        showDeleteModal,
        setShowDeleteModal,
        activeTripModalProps,
        setActiveTripModalProps,
        showEditTripModal,
        setShowEditTripModal,
        showPublishTripModal,
        setShowPublishTripModal,
        showCopyModal,
        setShowCopyModal,
        showMoveToTripModal,
        setShowMoveToTripModal
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
};
